import React from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';
import Modal from 'simple-react-modal';
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import DetailsRoundedIcon from '@material-ui/icons/DetailsRounded';
import classnames from 'classnames';

import VideoPlayer from '../../blogComponents/SimpleVideoPlayer';
import { ANCHOR_VIDEOS_ARCHIVE_VIDEO, ANCHOR_VIEW_PURCHASED_CLIPSTORE_VIDEO } from '../../../constants/apiUrls/apiUrls';
import callApi from '../../../utils/callApi';
import NotificationStore from '../../../store/NotificationStore';
import PayPerViewStore from '../../../store/PayPerViewStore';
import { anchorIsNakedNewsLive, buildAnchorCheckoutLink, buildAnchorLink } from '../../../utils/helpers';

import './PrivateVideo.css';
import LiveEventsContent from './PrivateContentComponents/LiveEventsContent';
import {
  linkToPaymentPage,
  LockIconContainer,
  PriceForClipStoreItem,
} from './PrivateContentComponents/PrivateContentUtils';
import PrivateContentDescription from './PrivateContentComponents/PrivateContentDescription';
import LikesAndViewsCount from './LikesAndViewsCount';
import SubscribeToViewCTAButton from './SubscribeToViewCTAButton';


const DATE_FORMAT = 'MMMM DD, YYYY';


class PrivateVideo extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showModal: false,
      privateVideo: null,
      showPayPerViewModal: false,
      anchorShortUrl: '',
      shouldBlurContent: true,
      userCanAccessContent: false,
      isBanned: false,
    };
  }

  componentDidMount() {
    const anchor = this.getCurrentAnchor();
    this.setBlurringForContent(anchor);
    this.setBanStatus(anchor);
    this.checkIfUserCanAccessContent();
    this.buildAnchorShortUrl(anchor);
  }

  buildAnchorShortUrl = () => {
    this.setState({
      anchorShortUrl: buildAnchorLink({
        id: this.props.anchorId,
        name: this.getCurrentAnchor?.()?.name,
      }),
    });
  };

  getCurrentAnchor = () => this.props.anchors?.find((anchor) => anchor.id === this.props.media?.anchorId);

  componentDidUpdate(prevProps) {
    const isNakedNewsLivePage = window.location.pathname === '/live';
    if (prevProps.media.anchorId !== this.props.media.anchorId) {
      const anchorData = this.getCurrentAnchor();
      this.setBlurringForContent(this.props.media.anchorId || this.props.anchorId);
      this.setState({
        anchorShortUrl: buildAnchorLink({
          id: isNakedNewsLivePage ? 241 : this.props.anchorId,
          name: anchorData?.name,
        }),
      });
    }
    if (PayPerViewStore.newItemWasPurchased && this.props.selectedClipPrice.id === this.props.media.id) {
      this.fetchVideo(this.props.anchorId, this.props.media.id);
      PayPerViewStore.setNewItemWasPurchased(false);
    }
  }

  checkIfUserCanAccessContent = () => {
    const { payPerViewNav, typeOfListing, user, isClipStorePage } = this.props;
    const isClipStoreTab = payPerViewNav === 'New' && typeOfListing === 'clipstore';
    const { authenticated } = user || {};
    if (!this.state.isBanned && (isClipStorePage || isClipStoreTab) && authenticated) {
      this.setState({ userCanAccessContent: true });

      return true;
    }

    return false;
  };

  setBanStatus = (anchor) => {
    const { user, anchorId } = this.props;
    const { anchorSubscriptions } = user?.user?.account || {};
    const anchorID = anchor?.id || anchorId;
    if (anchorSubscriptions) {
      const subscribedToAnchor = anchorSubscriptions.filter((anchorData) =>
        parseInt(anchorData.subCategory, 10) === anchorID);
      const userIsBanned = subscribedToAnchor?.[0]?.isBanned;
      this.setState({ isBanned: userIsBanned });
    }
  };

  setBlurringForContent = (currentAnchor) => {
    const { anchorId, typeOfListing, isPurchasedTab, blurContent } = this.props;
    const id = currentAnchor?.id || anchorId;
    if ((/* anchorIsNakedNewsLive(id) || typeOfListing === 'fanzone' ||*/ isPurchasedTab) || !blurContent) {
      this.setState({ shouldBlurContent: false });
    }
  };

  getAnchorId = (anchId, anchorId) => {
    if (anchId) {
      return anchId;
    }

    return anchorId;
  };

  fetchVideo = (anchId, videoId) => {
    const { anchorId, media, typeOfListing } = this.props;

    const id = this.getAnchorId(media.anchorId, anchorId);

    const vidId = videoId ? videoId : media.id;

    const url = (typeOfListing !== 'clipstore') ? ANCHOR_VIDEOS_ARCHIVE_VIDEO : ANCHOR_VIEW_PURCHASED_CLIPSTORE_VIDEO;

    const privateGalleriesUrl = url.
      replace('{id}', encodeURIComponent(id)).
      replace('{videoId}', encodeURIComponent(vidId));

    callApi(privateGalleriesUrl, 'GET', undefined, undefined, undefined, true, true, true).
      then((res) => {
        const privateVideo = {
          ...res.data,
          imageUrl: res.data.snapshotUrl,
        };
        this.setState({ privateVideo, showModal: true });
      }).
      catch((error) => {
        console.error(error);
      });
  };

  openModal = () => {
    const {
      isBanned,
      typeOfListing,
      openPayPerViewModal,
      price,
      media,
      title,
      user,
      payPerViewNav,
      subscribed,
    } = this.props;
    const isGuestUserOnFanzone = !subscribed && typeOfListing === 'fanzone';

    if ((payPerViewNav === 'New' && typeOfListing === 'clipstore' && !isBanned)) {
      openPayPerViewModal(price, title, media.id, 'VIDEO');
      PayPerViewStore.setCurrentlySelectedAnchor(media.anchorName);
    } else if (isBanned) {
      NotificationStore.error('Banned from following this model. Please contact support.');
    } else if (!isGuestUserOnFanzone || typeOfListing === 'clipstore') {
      this.fetchVideo();
    }
  };

  closeModal = () => {
    this.setState({ showModal: false });
  };

  getGalleryItemLink = () => {
    const { anchorId, subscribed, typeOfListing, isPurchasedTab, isClipStorePage } = this.props;
    const { anchorShortUrl, userCanAccessContent } = this.state;

    if ((isPurchasedTab || (typeOfListing === 'clipstore' && subscribed)) && !isClipStorePage) {
      return '?filter=clipstore';
    } else if (userCanAccessContent || subscribed) {
      return '#';
    }

    return linkToPaymentPage(subscribed, anchorId, anchorShortUrl);
  };

  sentToAcordingLink = () => {
    const { anchorId, subscribed, anchorShortUrl } = this.props;
    if (subscribed) {
      return `/${anchorShortUrl}`;
    }

    return buildAnchorCheckoutLink(anchorId, anchorShortUrl);
  };

  openClipStorePaymentModal = () => {
    const {
      price,
      media,
      title,
      customPriceForFanPlus,
    } = this.props;
    this.props.openPayPerViewModal(price, title, media.id, media.type, customPriceForFanPlus);
    PayPerViewStore.setCurrentlySelectedAnchor(media.anchorName);
    PayPerViewStore.setCurrentlySelectedAnchorID(media.anchorId);
  };

  handleContentClick = () => {
    const { userCanAccessContent, isBanned } = this.state;
    const { isPurchasedTab, user, typeOfListing, payPerViewNav } = this.props;
    const canAccessClipStore = !isBanned &&
      payPerViewNav === 'New' && typeOfListing === 'clipstore' && user.authenticated;

    if (isBanned) {
      NotificationStore.error('Banned from following this model. Please contact support.');
    } else if ((userCanAccessContent || canAccessClipStore) && !isPurchasedTab) {
      this.openClipStorePaymentModal();
    } else {
      this.openModal();
    }
  };

  render() {
    const { showModal, privateVideo, shouldBlurContent } = this.state;
    const {
      media,
      allAnchors,
      anchorId,
      subscribed,
      user,
      title,
      coverPhoto,
      date,
      showDescription = true,
      isBanned,
      needClasses = false,
      videoClass,
      liveEvents = false,
      typeOfListing,
      price,
      payPerViewNav,
      isPurchasedTab,
    } = this.props;
    const time = moment.utc(media.durationInMs).format('HH : mm : ss');
    const isClipStoreContent = typeOfListing === 'clipstore';
    const isFanzone = typeOfListing === 'fanzone';

    if (liveEvents) {
      return (
        <div className="content-item-container">
          <LiveEventsContent
            coverPhoto={coverPhoto}
            isGallery={false}
            isLiveEventsSection={liveEvents}
            linkToDirectTo={this.sentToAcordingLink()}
            shouldBlurContent={shouldBlurContent}
          />
        </div>
      );
    }

    return (
      <div className="content-item-container">
        <Link
          className="content-item gallery-item"
          to={this.getGalleryItemLink()}
          onClick={this.handleContentClick}
        >
          <div
            className={classnames(
              'content-item-thumbnail',
              'private-video-thumbnail', { 'private-video-thumbnail-trending': needClasses })}
          >
            <div
              className={classnames(
                'private-video-content-preview', { 'blur': shouldBlurContent })}
              style={{ background: `url(${coverPhoto}) no-repeat center center / cover` }}
            >
              <div
                alt="anchor-logo"
                className="anchor-side-pic"
                style={{ backgroundImage: `url(${this.state.anchorSidePic}` }}
              />
            </div>
            <div className="private-video-content-after-overlay" />
            <div
              className={
                classnames('private-video-details',
                  { 'full-height': (subscribed && isFanzone) || (isPurchasedTab) })
              }
            >
              <div className="private-video-play-icon">
                <DetailsRoundedIcon
                  style={{
                    fontSize: 50,
                    transform: 'rotate(-90deg)',
                    margin: '6px auto auto 10px',
                  }}
                />
              </div>
              <SubscribeToViewCTAButton
                showButton={!subscribed && isFanzone}
              />
              <PriceForClipStoreItem
                payPerViewNav={payPerViewNav}
                price={price}
              />
            </div>
            {media.durationInMs && subscribed &&
              <div className="private-video-time-icon">
                <AccessTimeIcon />
                {time}
              </div>
            }
          </div>
          <PrivateContentDescription
            allAnchors={allAnchors}
            leftTitle={moment(date).format(DATE_FORMAT)}
            media={media}
            shouldShowDescription={showDescription}
            title={title}
          />
        </Link>
        <LikesAndViewsCount
          anchorId={anchorId}
          isClipStoreContent={isClipStoreContent}
          media={media}
          subscribed={subscribed}
        />
        <Modal
          containerClassName="private-video-modal"
          show={showModal}
          onClose={() => this.setState({ showModal: false })}
        >
          <VideoPlayer
            autoPlayVideo={true}
            clip={privateVideo}
            user={user}
            videoClass={videoClass}
          />
          <div className="private-video-modal-caption">
            <div className="private-video-modal-title">
              {media.title}
            </div>
            <span className="private-gallery-image-count">{moment(media.date).format(DATE_FORMAT)}</span>
            <div className="private-video-modal-description">
              {media.description}
            </div>
            <button className="btn btn-red private-video-close" onClick={this.closeModal}>Close</button>
          </div>
        </Modal>
      </div>
    );
  }
}


export default PrivateVideo;
